import "./stylenews.css";
import React from "react";
import { TopMenu } from "../../components/topmenu/TopMenu";
import { Pagination } from "antd";
import moment from "moment";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { getNews, getFileById } from "../../services/index";
import { baseURL, imgUrl } from "../../constants/index";

export class NewsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curPage: 1,
      total: 0,
      newList: [],
      newsType: ["公司新闻", "新闻资讯"],
      journalism_type: "公司新闻",
    };
  }
  componentDidMount() {
    if(localStorage.getItem("curPage")){
      this.getNewList({
        page: parseInt(localStorage.getItem("curPage")),
        pageSize: 2,
        news: {
          journalism_type: localStorage.getItem("typeName"),
        },
      });
      this.setState({
        curPage:parseInt(localStorage.getItem("curPage")),
        journalism_type:localStorage.getItem("typeName"),
      })
    }else{
      this.getNewList({
        page: this.state.curPage,
        pageSize: 2,
        news: {
          journalism_type: this.state.journalism_type,
        },
      });
    }
  }
  getNewList(params) {
    getNews(params).then(async (res) => {
      if (res.code == 200) {
        let list = res.data.data;
        let newObj1 = await getFileById({
          id: parseInt(list[0].cover_photo),
        }).then((res1) => {
          return {
            ...list[0],
            cover_photo: baseURL + imgUrl + res1.data[0].name,
          };
        });
        let newObj2 = null;
        if (list.length == 2) {
          newObj2 = await getFileById({
            id: parseInt(list[1].cover_photo),
          }).then((res1) => {
            return {
              ...list[1],
              cover_photo: baseURL + imgUrl + res1.data[0].name,
            };
          });
        }
        this.setState({
          newList: list.length==2?[newObj1,newObj2]:[newObj1],
          total: res.data.total,
        });
      }
    });
  }
  onChange(pageNumber) {
    this.getNewList({
      page: pageNumber,
      pageSize: 2,
      news: {
        journalism_type: this.state.journalism_type,
      },
    });
  }
  getNewsListByType(journalism_type) {
    this.setState({
      curPage: 1,
      journalism_type,
    });
    this.getNewList({
      page: 1,
      pageSize: 2,
      news: {
        journalism_type,
      },
    });
  }
  savePage(){
    console.log(this.state.curPage);
    localStorage.setItem("curPage",this.state.curPage);
    localStorage.setItem("typeName",this.state.journalism_type);
  }
  render() {
    return (
      <div className="news_div">
        <div className="news_list_div">
          <div className="news_category">
            <div className="news_category_items">
              {this.state.newsType.length > 0 &&
                this.state.newsType.map((i) => {
                  return (
                    <div
                      className={
                        this.state.journalism_type == i
                          ? "category_item category_item_active"
                          : "category_item"
                      }
                      key={i}
                      onClick={() => {
                        this.getNewsListByType(i);
                      }}
                    >
                      <span className="category_link">{i}</span>
                    </div>
                  );
                })}
            </div>
          </div>
          <div
            id="news_list_content_id"
            className="news_list_content"
            data-animation="once"
            loaded="true"
            min-height="417"
            animated="true"
          >
            <div className="news_litem">
              <div className="news_litem_news">
                {this.state.newList.length > 0 &&
                  this.state.newList.map((i) => {
                    return (
                      <div className="p_articles" key={i.id}>
                        <div className="p_images higher">
                          <div className="p_thumbnail" onClick={()=>{
                            this.savePage()
                          }}>
                            <Link to={`/detail?fileid=${i.id}`}>
                              <img src={i.cover_photo} alt={i.name} />
                            </Link>
                          </div>
                        </div>
                        <div className="p_content">
                          <div className="p_header">
                            <div className="p_TitleBox">
                              <h3 className="p_title" onClick={()=>{
                                this.savePage()
                              }}>
                                <div className="font" title={i.name}>
                                  <Link to={`/detail?fileid=${i.id}`}>
                                    {" "}
                                    {i.name}
                                  </Link>
                                </div>
                              </h3>
                            </div>
                            <div className="p_assist">
                              <div className="p_TimeBox ">
                                <div className="p_AssistNameA">
                                  <div className="font">
                                    <span>发布时间：</span>
                                  </div>
                                </div>
                                <div className="p_time">
                                  <div className="font">
                                    <i className="iconfont"></i>
                                    {moment(i.journalism_time).format(
                                      "YYYY-MM-DD"
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="p_SummaryBox ">
                            <div className="p_nameB">
                              <div className="font">
                                <span className="i_summary">{"摘要："}</span>
                              </div>
                            </div>
                            <article className="p_summary" title={i.abstracts}>
                              {i.abstracts}
                            </article>
                          </div>
                          <div className="p_KeywordBox">
                            <div className="p_AssistNameF">
                              <div className="font">
                                <span className="i_keywords">{i.antistop}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>

            <div className="page">
              <Pagination
                showQuickJumper
                current={this.state.curPage}
                // defaultCurrent={2}
                total={this.state.total}
                showSizeChanger={false}
                onChange={(pageNumber) => {
                  this.setState({
                    curPage: pageNumber,
                  });
                  this.onChange(pageNumber);
                }}
                pageSize={2}
              />
            </div>
          </div>
        </div>
        <TopMenu />
      </div>
    );
    // }
  }
}
